import React from "react";
import { Switch, Redirect } from "react-router-dom";
import {
  InvestmentView,
  TradeOrderInstruction,
  TradeReconcilation,
  TransactionView,
  TransactionViewDetails,
  TradeOrderInvestment,
} from "../layouts";

import { ROUTES, MANAGE_TRADE_ROUTES, ApplicationRoute } from "../utils";

const menu = "trade";
export const ManageTradeRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRADE_ROUTES.TRANSACTION_VIEW}
        component={TransactionView}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRADE_ROUTES.INVESTMENT_VIEW}
        component={InvestmentView}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRADE_ROUTES.TRADE_ORDER_INSTRUCTION}
        component={TradeOrderInstruction}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRADE_ROUTES.TRADE_ORDER_RECONCILATION}
        component={TradeReconcilation}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRADE_ROUTES.TRANSACTION_VIEW_DETAILS}
        component={TransactionViewDetails}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRADE_ROUTES.TRADE_ORDER_INVESTMENT}
        component={TradeOrderInvestment}
      />

      <Redirect
        exact
        from={ROUTES.TRADE}
        to={MANAGE_TRADE_ROUTES.TRANSACTION_VIEW}
      />
    </Switch>
  );
};
